import ShopService from '../services/shop-service';
import _ from 'lodash';
import EventBus from '../services/event-bus';
import { EVENTS } from '../services/constants';
import { Order } from '../../types';
import PromoService from '../services/PromoService';

function recalcFees(order) {
    if (order.SaleAreaId == ShopService.SALE_AREAS.DELIVERY && order.AddressId != null) {
        if (order.stuart_ShippingFee) {
            order.ShippingFee = order.stuart_ShippingFee;
        } else {
            let zone = order.deliveryZone;
            if (zone) {
                // if zone not found, its using stuart
                // will be calculted later (when choosing delivery time, after setting address)
                order.ShippingFee = zone.ShippingFee;
            }
        }
    } else if (order.shop.info.salon?.active) {
        order.ShippingFee = order.stuart_ShippingFee;
    } else {
        order.ShippingFee = 0;
    }
    if (order.promo_code) {
        let isPercentageType = (promoCode) => promoCode.ReductionType == PromoService.REDUCTION_PERCENTAGE;
        let isAmountType = (promoCode) => promoCode.ReductionType == PromoService.REDUCTION_AMOUNT;

        if (isPercentageType(order.promo_code)) {
            order.Discount = -order.Subtotal * (order.promo_code.ReductionValue/100);
        } else if (isAmountType(order.promo_code)) {
            order.Discount = -order.promo_code.ReductionValue;
        }
    } else {
        order.Discount = 0;
    }
    if (order.SaleAreaId == ShopService.SALE_AREAS.TICKET) {
        order.ProcessingFee = 0;
    } else {
        order.ProcessingFee = order.shop.OrderProcessingFee;
    }
    setOrderTotal(order);
}

function setOrderTotal(order) {
    _.defaults(order, {
        ShippingFee: 0,
        ProcessingFee: 0,
        Tip: 0,
        Discount: 0
    });
    order.Total = +order.Subtotal + +order.ShippingFee + +order.ProcessingFee + +order.Tip + +order.Discount;
    order.Total = _.round(order.Total,2)
    if (order.Total < 0) {
        order.Total = 0;
    }
    order.Remain = order.Total;
    resetPaymentRequestAmounts(order);
}

function resetPaymentRequestAmounts(order: Order) {
    let remain = _.round(order.Remain,2);
    let fidPayment, fidCard, cardPayment, card;
    for(let i in order.paymentRequest.fidelitePayments) {
        fidPayment = order.paymentRequest.fidelitePayments[i];
        // fidCard = _.find(order.client.fidelite_cards,(fidCard) => fidCard.ShopId == order.ShopId && fidCard.cardno == fidPayment.cardno);
        fidCard = _.find(order.client?.fidelite_cards,(fidCard) => fidCard.id == fidPayment.id);
        if (fidCard) {
            fidPayment.Amount = Math.min(remain, _.floor(fidCard.nbPoints,2));
            remain -= fidPayment.Amount;
        } else {
            // card not found in client list, dont use it; will be removed 2 lines below
            fidPayment.Amount = 0;
        }
    }
    _.remove(order.paymentRequest.fidelitePayments,(fidPayment)=>fidPayment.Amount == 0);
    for(let k in order.paymentRequest.comoPayments) {
        let comoPayment = order.paymentRequest.comoPayments[k];
        comoPayment.Amount = Math.min(remain, _.floor(comoPayment.Amount,2));
        remain -= comoPayment.Amount;
    }
    _.remove(order.paymentRequest.comoPayments,(comoPayment)=>comoPayment.Amount == 0);
    for(let j in order.paymentRequest.cardPayments) {
        cardPayment = order.paymentRequest.cardPayments[j];
        cardPayment.Amount = _.round(remain,2);
        remain -= cardPayment.Amount;
        if (remain < 0) {
            remain = 0;
        }
    }
    _.remove(order.paymentRequest.cardPayments,(cardPayment)=>cardPayment.Amount == 0);
    EventBus.$emit(EVENTS.requestSaveCart);
}


export default {
    recalcFees,
    resetPaymentRequestAmounts,
}